import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import { GetCheckinCheckoutapiByEmployeeId } from "../../../api/api";

function CheckInDettails() {
  const dispatch = useDispatch();
  const [checkInData, setCheckInData] = useState([]);
  const { data } = useSelector((state) => state?.PopupReducer?.modal || {});

  useEffect(() => {
    if (data) {
      fetchCheckinCheckout(data);
    }
  }, [data]);

  const fetchCheckinCheckout = async (data) => {
    try {
      const res = await GetCheckinCheckoutapiByEmployeeId(data);
      if (res?.data?.status === true) {
        setCheckInData(res?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  const handleClose = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "",
        showModal: false,
      })
    );
  };

  return (
    <div className="rightModal taskModal">
      <div className="modal-header p-3">
        <h4 className="m-0">Check-In/Check-Out Details</h4>
        <button className="btnClose ms-auto" onClick={handleClose}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4">
        {checkInData.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="table-light">
                <tr>
                  <th>Employee Name</th>
                  <th>Operation</th>
                  <th>Time</th>
                  <th>Image</th>
                </tr>
              </thead>
              <tbody>
                {checkInData?.map((item) => (
                  <tr key={item?._id}>
                    <td>{item?.employee_name}</td>
                    <td>{item?.operation}</td>
                    <td>{item?.in_time || item?.out_time}</td>
                    <td>
                      <img
                        src={`${process.env.REACT_APP_IMAGE_URL}/${item.image_dataset_path}`}
                        alt="snapshot"
                        height={50}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>No check-in/checkout records found.</p>
        )}
      </div>
    </div>
  );
}

export default CheckInDettails;
